<template>
  <div class="daily-markets">
    <div class="daily-markets__header">
      <div class="daily-markets__header-title">Newsletters</div>
    </div>
    <p class="daily-markets__info">
      Access the Market Focus and Daily Markets newsletters to receive comprehensive market
      insights, news, data analysis, and key indicators at the intersection of politics and
      prediction markets.
    </p>
    <div class="daily-markets__line"></div>
    <div class="daily-markets__articles">
      <div v-for="item in items" :key="item.link">
        <router-link :to="dailyMarketPageLink(item)" class="daily-markets__link">
          {{ item.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script src="./daily-markets.js"></script>
<style src="./daily-markets.scss" lang="scss"></style>
